/**
 * @generated SignedSource<<6ae18c4349e0dfbbc576bf59b624eb05>>
 * @relayHash 2ca7c30a2e092e2e737cf7ac0b6fb178
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71dc3da69bc58c80b958165df446d23e7dfdde9b82e699b257eab219c9c6d039

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { pageLayout_projectsDirectoryLayout_RootQuery } from './pageLayout_projectsDirectoryLayout_RootQuery.graphql';

const node: PreloadableConcreteRequest<pageLayout_projectsDirectoryLayout_RootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "71dc3da69bc58c80b958165df446d23e7dfdde9b82e699b257eab219c9c6d039",
    "metadata": {},
    "name": "pageLayout_projectsDirectoryLayout_RootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
